var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16V28",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9376 24.5206C29.238 23.8117 30.2654 22.6898 30.8574 21.3321C31.4495 19.9745 31.5725 18.4583 31.2072 17.0229C30.8419 15.5875 30.0089 14.3146 28.8398 13.4052C27.6707 12.4958 26.2321 12.0016 24.7509 12.0006H23.0709C22.6673 10.4396 21.9151 8.99041 20.8709 7.76195C19.8266 6.5335 18.5174 5.55776 17.0417 4.90811C15.5661 4.25845 13.9623 3.95177 12.3511 4.01114C10.7398 4.0705 9.16301 4.49436 7.73916 5.25085C6.31531 6.00734 5.08147 7.07677 4.13042 8.37874C3.17937 9.68071 2.53584 11.1813 2.24823 12.7678C1.96062 14.3543 2.0364 15.9853 2.46987 17.5383C2.90335 19.0913 3.68325 20.5258 4.75092 21.734",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0837 21.3333L16.7503 16L11.417 21.3333",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.66e40d64f224dedbc76d529b60820199.svg";
export { ForwardRef as ReactComponent };